module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.researchGroupCharacter === 'leader') ? _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "tabs-box"
  }, [_c('div', {
    staticClass: "at-tabs__header"
  }, [_c('div', {
    class: ['at-tabs__item', _vm.tabType === 1 && 'at-tabs__item--active'],
    on: {
      "click": function () {
        this$1.tabType = 1
      }
    }
  }, [_vm._v("\n                       课题组成员\n                     ")]), _vm._v(" "), _c('div', {
    class: ['at-tabs__item', _vm.tabType === 2 && 'at-tabs__item--active'],
    on: {
      "click": function () {
        this$1.tabType = 2
      }
    }
  }, [_vm._v("\n                 申请列表\n               ")])])]), _vm._v(" "), (_vm.tabType === 1) ? _c('div', [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer_3"
  }, _vm._l((_vm.memberList), function(member, index) {
    return _c('router-link', {
      key: index,
      staticClass: "outer_attr",
      attrs: {
        "to": {
          name: 'ResearchMemberDetail',
          query: {
            memberIndex: index
          }
        }
      }
    }, [_c('div', {
      staticClass: "group"
    }, [_c('div', {
      staticClass: "attr_name"
    }, [_vm._v(_vm._s(member.memberName))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [(member.approveType === _vm.approveTypeNone) ? _c('span', {
      staticClass: "approve_none"
    }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[member.approveType]))]) : _vm._e(), _vm._v(" "), (member.approveType === _vm.approveTypeAll) ? _c('span', {
      staticClass: "approve_required"
    }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[member.approveType]))]) : _vm._e(), _vm._v(" "), (member.approveType === _vm.approveTypeThreshold) ? _c('span', {
      staticClass: "approve_required"
    }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[member.approveType]) + " ")]) : _vm._e(), _vm._v(" "), _c('svg', {
      staticClass: "liveiconput",
      attrs: {
        "t": "1583809028111",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1461",
        "width": "200",
        "height": "200"
      }
    }, [_c('path', {
      attrs: {
        "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
        "fill": "#929292",
        "p-id": "1462"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "empty"
    })])])
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "ft research-background-color",
    on: {
      "click": _vm.addMember
    }
  }, [_c('span', {
    staticClass: "word"
  }, [_vm._v("+")]), _vm._v(" "), _c('span', {
    staticClass: "addMember"
  }, [_vm._v("添加成员")])])]) : _vm._e(), _vm._v(" "), (_vm.tabType === 2 && _vm.approvalMemberList.length > 0) ? _c('div', [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer_3"
  }, _vm._l((_vm.approvalMemberList), function(member, index) {
    return _c('div', {
      key: index,
      staticClass: "outer_attr",
      on: {
        "click": function($event) {
          return _vm.goDetailOrApproval(member, index)
        }
      }
    }, [_c('div', {
      staticClass: "group"
    }, [_c('div', {
      staticClass: "attr_name"
    }, [_vm._v(_vm._s(member.memberName))]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('span', {
      staticClass: "approve_required"
    }, [_vm._v(_vm._s(member.status === 0 ? '待添加' : '已添加') + " ")]), _vm._v(" "), _c('svg', {
      staticClass: "liveiconput",
      attrs: {
        "t": "1583809028111",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1461",
        "width": "200",
        "height": "200"
      }
    }, [_c('path', {
      attrs: {
        "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
        "fill": "#929292",
        "p-id": "1462"
      }
    })])])]), _vm._v(" "), _vm._m(0, true)])
  }), 0)])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a151956a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchMemberManagement/ResearchMemberManagement.vue
// module id = 1702
// module chunks = 8